import { useId } from 'react'
import { Sparkles } from 'lucide-react'
import type { SearchMode } from './search-mode'

const MODES: Array<{ value: SearchMode; label: string }> = [
  { value: 'keywords', label: 'Keywords' },
  { value: 'ai', label: 'AI' },
]

/** The search bar's Keywords | AI switch (USA-1255): shows the picked mode and overrides it. */
export function SearchModeSwitch({
  mode,
  onModeChange,
}: {
  mode: SearchMode
  onModeChange: (mode: SearchMode) => void
}) {
  const name = useId()
  return (
    <div className="sf-mode" role="radiogroup" aria-label="Search mode" data-e2e="search-mode">
      {MODES.map((option) => (
        <label key={option.value} className="sf-mode__option" data-mode={option.value}>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={mode === option.value}
            onChange={() => onModeChange(option.value)}
          />
          <span className="sf-mode__label">
            {option.value === 'ai' ? (
              <Sparkles size={14} strokeWidth={2} aria-hidden="true" />
            ) : null}
            {option.label}
          </span>
        </label>
      ))}
    </div>
  )
}
